class ValidationResult {	
	constructor(error = null) {
		this.isValid = (error === null);
		this.error = error;
	}
};

export default ValidationResult;
